import { render, staticRenderFns } from "./DownloadPluginsModule.vue?vue&type=template&id=7ab32dbc&scoped=true"
import script from "./DownloadPluginsModule.vue?vue&type=script&lang=js"
export * from "./DownloadPluginsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab32dbc",
  null
  
)

export default component.exports